import Button from '@/common/components/Button'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { FormTransformers } from '@/common/utils/formTransformers'
import { useMaintenanceFinancialReviewSimpleEntriesApprove } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/financialReview/simpleEntries/useMaintenanceFinancialReviewSimpleEntriesApprove'
import { useForwardingTabContext } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/useForwardingTabContext'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

const FinancialReviewEntrySimpleEntryApprove = () => {
  const { workflow, forwarding } = useForwardingTabContext()

  const { id } = useParams()

  const queryClient = useQueryClient()

  const [messages, setMessages] = useState<string[] | boolean>(false)

  const { mutate: approve, isPending: approveIsPending } = useMaintenanceFinancialReviewSimpleEntriesApprove({
    financialReviewEntryId: workflow?.current_forwarding?.financial_review_entry?.id,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['maintenanceForwarding', forwarding.id],
        })

        queryClient.invalidateQueries({
          queryKey: ['maintenanceWorkflow', id],
        })
      },
      onError: (error) => {
        FormTransformers.errorsTransformer({
          setMessages,
        })(error)
      },
    },
  })

  return (
    <>
      <Button
        variant="success"
        onClick={() => approve()}
        isLoading={approveIsPending}
        operationKlassToCheckPermission="Client::Maintenance::FinancialReview::SimpleEntries::Approve"
      >
        Aprovar
      </Button>

      <ModalMessageSimple messages={messages} setMessages={setMessages} isError />
    </>
  )
}

export default FinancialReviewEntrySimpleEntryApprove
